// extracted by mini-css-extract-plugin
export var footer = "_oy-5";
export var fulfillmentInput = "_oy-0";
export var shipDateInput = "_oy-1";
export var shipmentModal = "_oy-2";
export var shipmentModalContent = "_oy-3";
export var tableContainer = "_oy-4";